import React, { useState } from "react";
import { Navbar, Container, Nav } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FaBars } from "react-icons/fa";
import logo from "../images/TP-_logo-orizz-claim-color-white-text.png";
import logoInvert from "../images/sud-ricambi-logo-symbol-white.png";
import logoInvert2 from "../images/amotive-logo-symbol-inverted-cut.png";

function NavbarMobile() {
  const [expanded, setExpanded] = useState(false);

  return (
    <Navbar
      expand={false}
      expanded={expanded}
className="navbar-mobile m-3 rounded-pill shadow"
      style={{
        background: "rgba(121,9,9,1)",
        padding: "14px 18px",
      }}
    >
      <Container fluid className="p-0 d-flex align-items-center">
        {/* LOGO */}
        <Navbar.Brand className="me-auto">
          <img src={logo} alt="Technoparts" style={{ maxWidth: "120px" }} />
        </Navbar.Brand>

        {/* SUD RICAMBI */}
        <Link to="/sud-ricambi" className="me-3">
          <img
            src={logoInvert}
            alt="Sud Ricambi"
            style={{ width: "28px" }}
          />
        </Link>

        {/* AMOTIVE */}
        <Link to="/amotive" className="me-3">
          <img
            src={logoInvert2}
            alt="Amotive"
            style={{ width: "22px" }}
          />
        </Link>

        {/* HAMBURGER */}
        <Navbar.Toggle
          className="border-0"
          onClick={() => setExpanded(!expanded)}
        >
          <FaBars className="text-white fs-3" />
        </Navbar.Toggle>

        {/* MENU COLLASSABILE */}
        <Navbar.Collapse className="mt-3">
          <Nav className="gap-3">
            <Link to="/proforma" onClick={() => setExpanded(false)}>
              PROFORMA
            </Link>

            <a
              href="https://dashboard.technoparts.it/qlik/tp.html"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => setExpanded(false)}
            >
              QLIK
            </a>

            {/* altri elementi */}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavbarMobile;
